// promise middleware for Redux from Naresh :)

import { stringFromErrorOrAny } from "../utils/tools";
import { failureAction, requestAction, successAction } from "./actions";

export default function promiseMiddleware() {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return (next: any) => (action: any) => {
        // cacheDuration is in seconds
        const { promise, type, cacheKey, cacheDuration, failInstantlyDebug, ...rest } = action;
        const __rest = rest; // workaround typescript issue since __rest is reserved auto-generated function

        if (!promise) {
            return next(action);
        }

        const success = successAction(type);
        const request = requestAction(type);
        const failure = failureAction(type);

        let result;
        __rest.promiseId = Date.now();
        if (cacheKey) {
            result = ajaxCache.get(cacheKey);
            if (result) {
                console.log("Cache hit: " + cacheKey);
                next({ __rest, type: request });
                return next({ __rest, req: result, type: success });
            }
        }

        next({ __rest, type: request });
        if (failInstantlyDebug) {
            console.log("FAIL INSTANTLY DEBUG: true");
            next({ __rest, error: "Debug action: fail requested", type: failure });
            return false;
        }
        else {
            return promise
                .then((req: any) => {
                    if (cacheKey) {
                        ajaxCache.add(cacheKey, req, cacheDuration);
                    }
                    next({ __rest, req, type: success });
                    return true;
                })
                .catch((error: any) => {
                    next({ __rest, error, errorMessage: stringFromErrorOrAny(error), type: failure });
                    console.log(error);
                    return false;
                });
        }
    };
}

export class CacheItem {
    //key: string;
    public value: any;
    public expiryTime: Date;
}

export class Cache {
    public items: { [key: string]: CacheItem };

    constructor() {
        this.items = {};
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    public add(key: string, value: any, durationInSeconds: number): void {
        const currentTime = new Date();
        currentTime.setMinutes(currentTime.getMinutes() + durationInSeconds / 60)
        // eslint-disable-next-line security/detect-object-injection
        this.items[key] = {
            key: key,
            value: value,
            expiryTime: currentTime,
        } as CacheItem;
    }

    public get(key: string): any {
        // eslint-disable-next-line security/detect-object-injection
        const item: CacheItem = this.items[key];
        if (item) {
            if (item.expiryTime > new Date()) {
                return item.value;
            }
        }
        return null;
    }
}

const ajaxCache: Cache = new Cache();
